// Botanical art sets — switch with SET:
//   "wild"  = pressed wildflower (blush cosmos, hydrangea, cornflower, lavender, buttercup)
//   "blush" = pink roses / peonies
//   "sage"  = original eucalyptus (also kept in /botanical-v1)
const SET = "wild";

const SETS = {
  wild: {
    corner: "/botanical-corner-wild.webp",
    divider: "/botanical-divider-wild.webp",
    spray: "/botanical-topright-wild.webp",
    bush: "/botanical-leftbush-wild.webp",
  },
  blush: {
    corner: "/botanical-corner-blush.webp",
    divider: "/botanical-divider-blush.webp",
    spray: "/botanical-topright-blush.webp",
    bush: "/botanical-leftbush-blush.webp",
  },
  sage: {
    corner: "/botanical-corner.webp",
    divider: "/botanical-divider.webp",
    spray: "/botanical-corner.webp",
    bush: "/botanical-corner.webp",
  },
};
const ART = SETS[SET];

export const Eucalyptus = ({ className = "", tone = "sage", variant = "corner" }) => (
  <img
    src={tone === "gold" ? "/botanical-gold.webp" : ART[variant] || ART.corner}
    alt=""
    aria-hidden="true"
    draggable="false"
    className={`botanical-art select-none pointer-events-none ${
      tone === "gold" ? "mix-blend-screen" : ""
    } ${className}`}
  />
);

export const Divider = ({ className = "" }) => (
  <img
    src={ART.divider}
    alt=""
    aria-hidden="true"
    draggable="false"
    className={`select-none pointer-events-none ${className}`}
  />
);

export const Wash = ({ className = "" }) => (
  <div
    className={`pointer-events-none absolute rounded-full ${className}`}
    style={{
      background:
        "radial-gradient(closest-side, rgba(122,139,123,0.20), transparent 72%)",
      filter: "blur(10px)",
    }}
    aria-hidden="true"
  />
);
